(()=>{
  let interval,
  counter = 0,
  duration = 250,
  limit = 40;
  interval = setInterval( () => {
    if(typeof gtag !== 'undefined'){
      initAnalytics();
      clearInterval( interval );
    } else if ( counter === limit ) {
      clearInterval ( interval );
    } 
  }, duration );


  function initAnalytics(){
    if(typeof gtag == 'undefined') return;

    // reserve_view_item_list
    if(document.getElementsByClassName('reserve-collection__grid').length > 0){
      gtag('event', 'reserve_view_item_list', {
        'pathname': window.location.pathname,
      }); 

      // reserve_select_item
      [...document.getElementsByClassName('reserve-collection__product')].forEach( el => {
        el.addEventListener('click', e => {
          e.preventDefault();

          const url = el.href;
          let navigated = false;

          function goToUrl() {
            if (navigated) return;
            navigated = true;
            window.location.href = url;
          }

          gtag('event', 'reserve_select_item', {
            'collection_pathname': window.location.pathname,
            'item_url': `/products/${url.split('/products/')[1]}`,
            'event_callback': function() {
              window.location.href = url;
            }
          })
          setTimeout(goToUrl,1000)
        })
      })
    };

    if(document.getElementsByClassName('reserve-product__body').length > 0){
      gtag('event', 'reserve_view_item', {
        'pathname': window.location.pathname,
      }); 

      [...document.getElementsByClassName('reserve-product__add-to-bag')].forEach( el => {
        el.addEventListener('click', e => {
          gtag('event', 'reserve_add_to_cart', {
            'pathname': window.location.pathname,
          }); 
        })
      })
    }
    
  }
})();